export default __webpack_public_path__ + "static/media/whitelabel-logo.3e96a347.svg";